import { AddOnPriceSimplifiedProps } from '~/components/AddOn/simplified/AddOnPriceSimplified';
import { Product } from './products';

export enum ModalActionTypes {
  SET_ACTIVE_MODAL = 'modal/setActiveModal',
  SET_MODAL_PRODUCT = 'modal/setModalProduct',
  SET_MODAL_PRICE_PRODUCT = 'modal/setModalPriceProduct',
  SET_MODAL_DATA = 'modal/setModalData',
  CLEAR_MODAL = 'modal/clearModal',
}

export interface ModalState {
  activeModal: string | null;
  modalProduct?: Product;
  modalPriceProduct?: AddOnPriceSimplifiedProps;
  modalData?: Record<string, unknown>;
}

export interface SetActiveModalAction {
  type: ModalActionTypes.SET_ACTIVE_MODAL;
  modalKey: string | null;
}

export interface SetModalPriceProductAction {
  type: ModalActionTypes.SET_MODAL_PRICE_PRODUCT;
  priceProduct: AddOnPriceSimplifiedProps;
}

export interface SetModalProductAction {
  type: ModalActionTypes.SET_MODAL_PRODUCT;
  product: Product;
}

export interface SetModalDataAction {
  type: ModalActionTypes.SET_MODAL_DATA;
  data: Record<string, unknown>;
}

export interface ClearModalAction {
  type: ModalActionTypes.CLEAR_MODAL;
}

export type ModalActions =
  | SetActiveModalAction
  | SetModalPriceProductAction
  | SetModalProductAction
  | SetModalDataAction
  | ClearModalAction;
